import * as yup from "yup";
import {INVALIDATION_TIP, REGEX} from "../../../const/validation";

export const lkSchema = yup.object().shape({
  first_name: yup
    .string()
    .required(INVALIDATION_TIP.FIELD_REQUIRED)
    .min(2, INVALIDATION_TIP.MIN_LENGTH_NAME)
    .matches(
      REGEX.FULL_NAME_REGEX,
      INVALIDATION_TIP.INCORRECT_NAME,
    ),
  last_name: yup.string().nullable(),
  company: yup.string().nullable(),
  position: yup.string().nullable(),
});
